module.exports = __webpack_public_path__ + "static/img/jigou-fujian-top.f82aff6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-fujian-top.png
// module id = zZro
// module chunks = 2